import { render } from "./DayComponent.vue?vue&type=template&id=18d31814"
import script from "./DayComponent.vue?vue&type=script&lang=js"
export * from "./DayComponent.vue?vue&type=script&lang=js"

import "./DayComponent.vue?vue&type=style&index=0&id=18d31814&lang=scss"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__